// https://stackoverflow.com/questions/9847580/how-to-detect-safari-chrome-ie-firefox-and-opera-browser

// Opera 8.0+
export const isOpera =
	// @ts-expect-error ts-migrate FIXME
	(!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

// Firefox 1.0+
// @ts-expect-error ts-migrate FIXME
export const isFirefox = typeof InstallTrigger !== 'undefined';

// Safari 3.0+ "[object HTMLElementConstructor]"
function checkRemoteNotification(p) {
	return p.toString() === '[object SafariRemoteNotification]';
}
export const isSafari =
	// @ts-expect-error ts-migrate FIXME
	/constructor/i.test(window.HTMLElement) ||
	// @ts-expect-error ts-migrate FIXME
	checkRemoteNotification(!window.safari || (typeof safari !== 'undefined' && window.safari.pushNotification));

// Internet Explorer 6-11
// @ts-expect-error ts-migrate FIXME
export const isIE = /* @cc_on!@ */ false || !!document.documentMode;

// Edge 20+
export const isEdge = !isIE && !!window.StyleMedia;

// Chrome 1+
// @ts-expect-error ts-migrate FIXME
export const isChrome = !!window.chrome && !!window.chrome.webstore;

// Blink engine detection
export const isBlink = (isChrome || isOpera) && !!window.CSS;
